import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { IConfigurationData, IPageQueryParams } from "src/app/domain/interfaces/configuration-data.interface";
import { CCGTakerService } from "src/app/domain/services/ccg-taker.service";
import { DownloadService } from "src/app/domain/services/download.service";
import { UserService } from "src/app/domain/services/user.service";
import { DialogComponent } from "../dialog/dialog.component";
import { LoadComponent } from "../load/load.component";

@Component({
	selector: "app-card",
	templateUrl: "./card.component.html"
})
export class CardComponent implements OnInit {
	actions: string[];
	@Input() response: IConfigurationData;
	@Output() eventButton = new EventEmitter<any>(true);
	@Output() secondEventButton = new EventEmitter<any>(true);

	constructor(
		private ccgTomadorService: CCGTakerService,
		private userService: UserService,
		private downloadService: DownloadService,
		private dialog: MatDialog,
		private router: Router
	) {}

	ngOnInit() {
		this.actions = localStorage.getItem("profileClaim").split(",");
	}

	goToNavigate(page: string, id: number, pageParams?: IPageQueryParams[]) {
		if (pageParams != undefined && pageParams.length > 0) {
			const p = {};
			pageParams.forEach(parm => {
				p[parm.name] = parm.value;
			});
			this.router.navigate([`${page}/${id}`], { queryParams: p });
		} else {
			this.router.navigate([`${page}/${id}`]);
		}
	}

	toTransmit(legalPersonId: number): void {
		const loadRef = this.dialog.open(LoadComponent, {
			panelClass: "custom-modalbox",
			disableClose: true
		});

		this.ccgTomadorService.sendDocument(legalPersonId).subscribe(
			(res: any) => {
				this.showModal("Sucesso", res.data.message, null, "ENTENDI");
				loadRef.close();
			},
			error => {
				loadRef.close();
			}
		);
	}

	printDocument(legalPersonId: number): void {
		this.ccgTomadorService.printDocument(legalPersonId).subscribe((response: any) => {
			this.downloadService.file(response, `application/pdf`, `BMG-Seguros`, `pdf`);
		});
	}

	resendPassword(id: string): void {
		this.userService.resendPassword(id).subscribe();
	}

	actionButton(data: any): void {
		this.eventButton.emit({ id: data });
	}

	showModal(title: string, text: string, firstNameButton: string, secondNameButton: string) {
		const dialogRef = this.dialog.open(DialogComponent, {
			data: { title, text },
			height: "238px",
			width: "480px"
		});
		dialogRef.componentInstance.firstNameButton = firstNameButton;
		dialogRef.componentInstance.secondNameButton = secondNameButton;
	}

	secondActionButton(data: any): void {
		this.secondEventButton.emit({ id: data });
	}
}
